import DashboardCalendarSettingPage from 'presentations/views/components/pages/DashboardCalendarSettingPage';
export default function Page() {
  return <DashboardCalendarSettingPage />;
}
